import Tavarakuljetukset from "./views/Tavarakuljetukset";
import Autojenkuljetukset from "./views/Autojenkuljetukset";
import Koneenkuljetukset from "./views/Koneenkuljetukset";
import { OrderStatus } from "./views/OrderStatus";
import { ProfileView } from "./views/ProfileView";
import { AdminView } from "./admin/AdminView";
import { DamageClaim } from "./views/DamageClaim";

function App(props) {
  console.log(props);
  const pageId = props.skt.id;

  switch (pageId) {
    case "tavarakuljetukset":
      return <Tavarakuljetukset skt={props.skt} />;
    case "autojenkuljetukset":
      return <Autojenkuljetukset skt={props.skt} />;
    case "koneenkuljetukset":
      return <Koneenkuljetukset skt={props.skt} />;
    case "tilaus":
      return <OrderStatus skt={props.skt} secret={props.skt.secret} />;
    case "login":
      return <ProfileView skt={props.skt} />;
    case "admin":
      return <AdminView />;
    case "damageclaim":
      return <DamageClaim skt={props.skt} />;
    default:
      break;
  }

  return <div>Unknown page {pageId}</div>;
}

export default App;
